import React from 'react';

const useInterval = (cb, delay, ...args) => {
    const savedCb = React.useRef();

    React.useEffect(() => {
        savedCb.current = cb;
    }, [cb]);

    React.useEffect(() => {
        const tick = () => {
            if (savedCb.current) {
                savedCb.current(...args);
            }
        };

        if (delay != null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
};

export default useInterval;
